<template>
  <!-- <v-ons-page id="map_page" :class="{'show': isPageShow}" @show="showMap($event)"> -->
  <v-ons-page id="map_page" :class="{'show': isPageShow}">
    <div class="map_top_function pc_none">
      <div class="address_input">
        <div class="address_input_left">
          <div class="address_back" @click="popPage()">
            <img src="../assets/images/common/arrow_back.svg" alt="戻る">
          </div>
          <Suggest :pageType="'map'"></Suggest>
        </div>
        <div class="address_input_right" @click="liftGrepSearch()">
          <img src="../assets/images/map/filter.svg" alt="条件を絞り込む">
        </div>
      </div>
      <div class="pin_filters">
        <div class="form_filter_radio">
          <input type="radio" id="all" v-model="pinFilterTypeModel" @change="changePinFilterType()" value="0">
          <label for="all">すべて</label>
        </div>
        <div class="form_filter_radio">
          <input type="radio" id="shop" v-model="pinFilterTypeModel" @change="changePinFilterType()" value="1">
          <label for="shop">店舗</label>
        </div>
        <div class="form_filter_radio">
          <input type="radio" id="atm" v-model="pinFilterTypeModel" @change="changePinFilterType()" value="2">
          <label for="atm">店外ATM</label>
        </div>
      </div>
    </div>
    <Header class="sp_none" :pageType="'map'"></Header>
    
    <div class="map_main_container" :class="{'full': isMapFullSize}">
      <div class="pc_wrapper sp_none">
        <div class="pc_search_information_container">
          <div class="pc_filters_function">
            <div class="search_text">
              <div class="search_text_left">
                <img src="../assets/images/common/search_icon.svg" alt="検索">
                <Suggest :pageType="'map'"></Suggest>
              </div>
              <div class="search_text_right">
                <div class="right_search">
                  <button type="button" @click="showSelectAreaDialog()">エリア</button>
                </div>
              </div>
            </div>
            <div class="pc_search_filter" @click="showGrepFilterDialog()">
              <img src="../assets/images/map/filter.svg" alt="条件を絞り込む">
              <span>条件を絞り込む</span>
            </div>
            <div class="pc_pin_filters">
              <div class="pc_form_filter_radio">
                <input type="radio" id="pc_all" v-model="pinFilterTypeModel" @change="changePinFilterType()" value="0">
                <label for="pc_all">すべて</label>
              </div>
              <div class="pc_form_filter_radio">
                <input type="radio" id="pc_shop" v-model="pinFilterTypeModel" @change="changePinFilterType()" value="1">
                <label for="pc_shop">店舗</label>
              </div>
              <div class="pc_form_filter_radio">
                <input type="radio" id="pc_atm" v-model="pinFilterTypeModel" @change="changePinFilterType()" value="2">
                <label for="pc_atm">店外ATM</label>
              </div>
            </div>
          </div>
          <SearchResult :result="positionFilterObjects" @select-list="hrefInfoDetail($event)"></SearchResult>
        </div>
      </div>

      <div class="sp_wrapper pc_none">
        <div id="detail_card_swiper_wrapper" >
          <div class="sp_map_button pan_center" @click="panCurrentPosition()">
            <img src="../assets/images/map/current_arrow.svg" alt="現在地">
          </div>
          <!-- <div class="sp_map_button toggle_visible" @click.stop="toggleVisible()">
            <img src="../assets/images/map/eye.svg" alt="表示" v-show="spCardVisibleFlag">
            <img src="../assets/images/map/eye_slash.svg" alt="非表示" v-show="!spCardVisibleFlag">
          </div> -->
          
          <swiper ref="mySwiper" :class="{hidden: !this.spCardVisibleFlag}" :options="swiperOptions" id="detail_card_swiper" @slideChange="onSlideChange()">
            <swiper-slide v-for="(result, i) of positionFilterObjects" :key="i">
              <div class="detail_card">
                <dl>
                  <dt>
                    <img src="../assets/images/map/shop_icon.svg" alt="店舗" v-if="result.siten_flg">
                    <img src="../assets/images/map/atm_icon.svg" alt="店外ATM" v-if="!result.siten_flg">
                  </dt>
                  <dd @click="hrefInfoDetail(result.id)">
                    <div class="close_button" @click.stop="infoClose()"><img src="../assets/images/map/close.svg"/></div>
                    <div class="shop_status" v-if="result.siten_flg">
                      <div class="badge sales" v-if="result.sales === '1'">営業中</div>
                      <div class="badge off_hours" v-if="result.sales === '2'">時間外</div>
                      <div class="badge off_hours" v-if="result.sales === '3'">窓口昼休業</div>
                      <span class="atm_status" v-if="(result.sales === '2' || result.sales === '3') && (result.atm === '1')">ATM稼働中</span>
                    </div>
                    <div class="shop_status" v-if="!result.siten_flg">
                      <div class="badge sales" v-if="result.atm === '1'">営業中</div>
                      <div class="badge off_hours" v-if="result.atm === '2'">時間外</div>
                    </div>
                    <p class="name">{{result.tenpo}}</p>
                    <p class="address">{{result.address}}</p>
                  </dd>
                </dl>
                <div class="card_bottom">
                  <div class="card_bottom_left">
                    <img src="../assets/images/map/distance_pin.svg" alt="距離">
                    <span v-if="result.distance >= 1000">{{toFixedChange(result.distance)}}km</span>
                    <span v-else>{{result.distance}}m</span>
                  </div>
                  <div class="card_bottom_right">
                    <a :href="encodeURL(result)" target="_blank" type="button" class="square_button">ルート案内</a>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>

        <div id="search_detail_list" ref="searchDetailList" :style="{'transform': `translate3d(0px, ${positionY}px, 0)`, 'transition': `transform ${transitionSpeed}s ease 0s`}" :class="isMounted ? 'show': ''">
          <ons-gesture-detector>
            <div class="gesture_wrapper">
              <div class="list_title_header" id="drag_area" v-show="!isListOpen">
                <div id="drag_bar">
                  <span></span>
                </div>
                <div id="list_title">店舗・ATM検索結果</div>
              </div>
              <v-ons-toolbar class="search_result_header" v-show="isListOpen">
                <div class="left" @click="liftDown()">
                  <div class="history_back">
                    <img src="../assets/images/common/arrow_back.svg" alt="戻る">
                  </div>
                </div>
                <div class="center title"  @click="liftDown()">現在地周辺</div>
                <div class="right">
                  <div class="filter" @click="liftGrepSearch()">
                    <img src="../assets/images/map/filter.svg" alt="条件を絞り込む">
                  </div>
                </div>
              </v-ons-toolbar>
              <div class="search_result_container" :style="{'height': screenHeight + 'px'}">
                <h2 :class="{show: isListOpen}">店舗・ATM検索結果</h2>
                <SearchResult :result="positionFilterObjects" @select-list="hrefInfoDetail($event)"></SearchResult>
              </div>
              <div id="result_bottom_bar">
                <button type="button" class="map_view_button" @click="liftDown()">
                  <img src="../assets/images/map/white_pin.svg" alt="マップを見る">
                  <span>マップを見る</span>
                </button>
              </div>
            </div>
          </ons-gesture-detector>
          
        </div>
      </div>

      <div id="map_container">
        <div id="googlemap" ref="googlemap"></div>
        <div class="map_button drawer" @click="toggleMapSize()">
          <img src="../assets/images/common/arrow_back.svg" alt="一覧を閉じる">
        </div>
        <div class="map_button pan_center" @click="panCurrentPosition()">
          <img src="../assets/images/map/current_arrow.svg" alt="現在地">
        </div>
        <div class="map_button zoom">
          <button type="button" @click="mapZoom('plus')">
            <img src="../assets/images/map/zoom_plus.svg" alt="ズームイン">
          </button>
          <hr>
          <button type="button" @click="mapZoom('minus')">
            <img src="../assets/images/map/zoom_minus.svg" alt="ズームアウト">
          </button>
        </div>
        <div class="map_button re_search" @click="reSearch()" >
          <button type="button">
            <img src="../assets/images/map/reload.svg" alt="このエリアを検索">
            <span>このエリアを検索</span>
         </button>
 
        </div>
      </div>
    </div>
  </v-ons-page>
</template>

<script>
import _ from 'lodash';
import Header from './partial/header.vue';
import SearchResult from './partial/searchResult.vue';
import Suggest from './partial/suggestInput.vue';

import { Loader } from '@googlemaps/js-api-loader';

import ApiService from '../services/api-service.js';
import ConfigService from '../services/config-service.js';
import store from '../store/store';

export default {
  name: 'Map',
  components: {
    Header,
    SearchResult,
    Suggest
  },
  props: [],
  data() {
    return {
      isPageShow: false,
      isCurrentRoute: this.$router.currentRoute.name === this.$options.name ? true : false,
      isOpen: false,
      searchResultList: true,
      positionY: 0,
      isMounted: false,
      transitionSpeed: 0,
      isListOpen: false,
      swiperOptions: {
        pagination: false
      },
      pinFilterTypeModel: '0', // 絞り込みv-model（すべて: '0', 店舗: '1', ATM: '2'）
      screenHeight: window.innerHeight,

      googleMap: null,
      google: null, // load callback google object
      boundsMap: null,
      googleMapOld: null,
      targetId:null,
      // marker関連
      marker: null,
      markers: [],
      currentMarker: null,
      positionAllObjects: [], // 該当店舗ATM全件オブジェクト
      positionFilterObjects: [], // 該当店舗ATM絞り込み結果オブジェクト
      atmPinImage: require("@/assets/images/map/atm_pin.png"),
      shopPinImage: require("@/assets/images/map/shop_pin.png"),

      // infoWindow関連
      infoWindows: [],
      infoShopIconImage: require("@/assets/images/map/shop_icon.svg"),
      infoAtmIconImage: require("@/assets/images/map/atm_icon.svg"),
      infoDistancePinImage: require("@/assets/images/map/distance_pin.svg"),
      //閉じるボタン
      closeImage:require("@/assets/images/map/close.svg"),

      isMapFullSize: false,
      currentLatitude: null,
      currentLongitude: null,

      spCardVisibleFlag: true // SP
    }
  },
  computed: {
    result: function() {
      return store.state.result;
    },
    swiper() {
      return this.$refs.mySwiper.$swiper
    },
    isMobile: function() {
      return store.state.isMobile;
    },
  },
  watch: {
    result: function(newVal, oldVal) {
      this.mapRender(newVal);
    },

    positionFilterObjects: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        // マーカー初期化
        _.forEach(this.markers, (mark) => {
          mark.setMap(null)
        });
  
        this.markers = [];
  
        if (_.size(newVal) > 0) {
          this.boundsMap = new this.google.maps.LatLngBounds();
          const inputName=store.getters.inputName;
          const nowIndex=this.swiper.activeIndex;
          let val;
          
          _.forEach(newVal, (target, index) => {
            if (target.latitude && target.longitude) {
              if(inputName===target.tenpo){
                this.swiper.activeIndex=index;
              }
              let iconImage = target.siten_flg ? this.shopPinImage : this.atmPinImage;
              let iconImageObject = {
                url: iconImage,
                scaledSize: new this.google.maps.Size(32, 40),
                // origin: new this.google.maps.Point(0,0), // origin
                // anchor: new this.google.maps.Point(0,0)
              };
      
              let marker = new this.google.maps.Marker({
                position: {'lat': Number(target.latitude), 'lng': Number(target.longitude)},
                map: this.googleMap,
                icon: iconImageObject,
                optimized: true,
              });

              this.boundsMap.extend(new this.google.maps.LatLng(Number(target.latitude), Number(target.longitude)));

              marker.set('id', target.id);
              const infoIconImageTag = target.siten_flg ? `<img src="${this.infoShopIconImage}" alt="店舗">` : `<img src="${this.infoAtmIconImage}" alt="店外ATM">`;
              
              let salesTag;
              let atmTag;

              if (target.siten_flg) {
                switch(target.sales) {
                  case '1':
                    salesTag = `<div class="badge sales">営業中</div>`;
                    break;
    
                  case '2':
                    salesTag = `<div class="badge off_hours">時間外</div>`;
                    break;
    
                  case '3':
                    salesTag = `<div class="badge off_hours">窓口昼休業</div>`;
                    break;
    
                  default:
                    salesTag = '';
                    break;
                }
    
                if (target.sales === '2' || target.sales === '3') { // ATM時間外 || ATM窓口昼休業
                  if (target.atm === '1') {
                    atmTag = `<span class="atm_status">ATM稼働中</span>`;
                  } else {
                    atmTag = '';
                  }
                } else {
                  atmTag = '';
                }
              } else {
                switch(target.atm) {
                  case '1':
                    salesTag = `<div class="badge sales">営業中</div>`;
                    break;

                  case '2':
                    salesTag = `<div class="badge off_hours">時間外</div>`;
                    break;

                  default:
                    salesTag = '';
                    break;
                }
                atmTag = '';
              }
  
              let distanceTag;
              if (target.distance >= 1000) {
                const exchangeDistance = _.round(target.distance / 1000, 1).toFixed(1);
                distanceTag = `<span>${exchangeDistance}km</span>`;
              } else {
                distanceTag = `<span>${target.distance}m</span>`;
              }
  
              const mapUrl = encodeURI(`https://www.google.com/maps/search/?api=1&query=${target.latitude},${target.longitude}`);
              const postalCodeTag = target.siten_flg ? `<span class="shop_postalcode">〒${target.yuubin}</span>` : '';
              const infoWindowString = `
                <div class="info_window">
                  <div class="shop_list">
                    <dl>
                      <dt>
                        ${infoIconImageTag}
                      </dt>
                      <dd id="info_link" data-id="${target.id}">
                        <div class="close_button" id="closeButton"><img src="${this.closeImage}" /></div>
                        <div class="shop_status">
                          ${salesTag}
                          ${atmTag}
                        </div>
                        <p class="shop_name">${target.tenpo}</p>
                        <p class="shop_address">
                          ${postalCodeTag}
                          ${target.address}
                        </p>
                      </dd>
                    </dl>
                    <div class="shop_list_bottom">
                      <div class="card_bottom_left">
                        <img src="${this.infoDistancePinImage}" alt="距離">
                        ${distanceTag}
                      </div>
                      <div class="card_bottom_right">
                        <a href="${mapUrl}" target="_blank" type="button" class="square_button">ルート案内</a>
                      </div>
                    </div>
                  </div>
                </div>
              `;
  
              let infoWindow = new this.google.maps.InfoWindow({
                content: infoWindowString,
                maxWidth: 'auto',
              });
  
              infoWindow.set('id', target.id);
  
              this.google.maps.event.addListener(infoWindow, 'domready', () => {
                const infoLinks = document.getElementById('info_link');
                const closeButton= document.getElementById('closeButton');
                let flg=false;
                closeButton.addEventListener('click', (event) => {
                    flg=true;
                    if (!this.isMobile) {
                      const id = marker.get('id');
        
                      _.forEach(this.markers, (mark, index) => {

                          mark.setIcon({
                            url: mark.icon.url,
                            scaledSize: new this.google.maps.Size(32, 40)
                          });
        
                          const targetInfoWindow = _.filter(this.infoWindows, (info) => {
                            return info.id === mark.id;
                          })[0];
        
                          targetInfoWindow.close();
                        
                      });
                    }
                    this.markers.push(marker);
               
                });


                infoLinks.addEventListener('click', (event) => {
                  if(flg){
                    flg=false;
                    return;
                  }
                  const id = infoLinks.dataset.id;
                  console.log(id);
                  this.$router.push({name: 'Detail', params: {animation: 'slide', id: id}});
                });
              });
      
              marker.addListener('click', () => {
                if (!this.isMobile) {
                  const id = marker.get('id');
    
                  _.forEach(this.markers, (mark, index) => {
                    if (mark.id === id) {
                      mark.setIcon({
                        url: mark.icon.url,
                        scaledSize: new this.google.maps.Size(46, 56)
                      });
    
                      const targetInfoWindow = _.filter(this.infoWindows, (info) => {
                        return info.id === mark.id;
                      })[0];
    
                      targetInfoWindow.open({
                        anchor: mark,
                        map: this.googleMap,
                        shouldFocus: true,
                      });
                    } else {
                      mark.setIcon({
                        url: mark.icon.url,
                        scaledSize: new this.google.maps.Size(32, 40)
                      });
    
                      const targetInfoWindow = _.filter(this.infoWindows, (info) => {
                        return info.id === mark.id;
                      })[0];
    
                      targetInfoWindow.close();
                    }
                  });
                } else {
                  this.spCardVisibleFlag = true;
                  const id = marker.get('id');
                  const index = _.findIndex(this.positionFilterObjects, (obj) => {
                    return obj.id === id;
                  });
  
                  if (index >= 0) {
                    this.swiper.slideTo(index);
                    let targetMarker = this.markers[index];
  
                    _.forEach(this.markers, (mark, index) => {
                      if (mark.id === targetMarker.id) {
                        mark.setIcon({
                          url: mark.icon.url,
                          scaledSize: new this.google.maps.Size(46, 56)
                        });
                      } else {
                        mark.setIcon({
                          url: mark.icon.url,
                          scaledSize: new this.google.maps.Size(32, 40)
                        });
                      }
                    });
                  }
                }
              });
      
              this.markers.push(marker);
              this.infoWindows.push(infoWindow);
              
              if (this.isMobile) {
                if(this.spCardVisibleFlag){
                  this.onSlideChange();
                }
              }
            }
          });
          if(this.googleMapOld){      
            this.googleMap.fitBounds(this.googleMapOld.LatLng(Number(this.googleMapOld.getCenter().lat()), Number(this.googleMapOld.getCenter().lng())));
            
          }else{
            this.googleMap.fitBounds(this.boundsMap);
          }
          this.boundsMapOld=null;
        }
      }
    },
  },
  methods: {
    popPage() {
      this.$router.replace({name: 'Search', params: {animation: 'slide'}});
    },
    liftDown() {
      this.positionY = 0;
      this.isListOpen = false;
    },
    showMap(event) {
      const ids = localStorage.getItem('ncbAtm.result') ? JSON.parse(localStorage.getItem('ncbAtm.result')) : store.getters.allResults;
      this.mapRender(ids);
    },
    mapRender(ids) {
      this.pinFilterTypeModel = '0'
      let overlay = this.$loading.show({
        // canCancel: true,
        color: '#000000',
        loader: 'spinner',
        width: 32,
        height: 32,
        backgroundColor: '#000000',
        opacity: 0.2,
        zIndex: 999
      });

      navigator.geolocation.getCurrentPosition(position => {
        const lat = position.coords.latitude;
        const lon = position.coords.longitude;

        let param = {
          'latitude': lat,
          'longitude': lon,
          'id': ids
        }

        ApiService.getContents(param)
          .then(data => {
            const cloneInfoData = _.clone(data.info)
            this.positionAllObjects = _.orderBy(cloneInfoData, 'distance', 'ask');
            const firstLatitude = this.positionAllObjects[0].latitude;
            const firstLongitude = this.positionAllObjects[0].longitude
            const loader = new Loader({
              apiKey: ConfigService.getMapApiKey(),
              version: "weekly"
            });

            const typeObj = localStorage.getItem('ncbAtm.type') ? JSON.parse(localStorage.getItem('ncbAtm.type')) : store.getters.searchType;
            let zoomLevel

            switch(typeObj.type) {
              case 'gps':
                zoomLevel = 15;
                break;

              case 'area':
                zoomLevel = 12;
                break;

              case 'filter':
                zoomLevel = 10;
                break;

              default:
                zoomLevel = 10;
                break;
            }
            let latitude=Number(firstLatitude)
            let longitude=Number(firstLongitude)
            if( this.googleMap){
              zoomLevel=this.googleMap.getZoom();
              latitude= this.googleMap.getCenter().lat();
              longitude=this.googleMap.getCenter().lng();
            }
            const mapOptions = {
              center: {lat:latitude, lng: longitude},
              zoom: zoomLevel,
              // maxZoom: 20,
              disableDefaultUI: true,
              mapId: '4e1bb28009b7a7cb'
            };

            loader.load()
              .then(async (google) => {
                window.google = google;
                this.google = google;
                
                this.googleMap = new this.google.maps.Map(this.$refs.googlemap, mapOptions);
                this.boundMap = new this.google.maps.LatLngBounds();
                this.positionFilterObjects = _.clone(this.positionAllObjects);
                navigator.geolocation.getCurrentPosition(async position => {
                  this.currentLatitude = mapOptions.center.lat?mapOptions.center.lat:Number(position.coords.latitude),
                  this.currentLongitude = mapOptions.center.lng?mapOptions.center.lng:Number(position.coords.longitude);
                  const CustomMarker = await require('../classes/CustomMarker').default;
                  this.currentMarker = new CustomMarker(this.googleMap, Number(position.coords.latitude), Number(position.coords.longitude));
                });

                this.google.maps.event.addListenerOnce(this.googleMap, 'idle', () => {
                  overlay.hide();
                  const zoom = this.googleMap.getZoom();

                  if (zoom > 20) {
                    this.googleMap.setZoom(18)
                  }
                });

                overlay.hide();
              }).catch(error => {
                console.log(error);
                overlay.hide();
              });
          }, error => {
            console.log(error);
            overlay.hide();
          }).catch(error => {
                console.log(error);
                overlay.hide();
              });
      }, error => {
        console.log(error);
        overlay.hide();
        this.$ons.notification.alert({
          'title': '',
          'messageHTML': `位置情報が無効になっています。<br>JR博多駅からの距離を表示します。`
        });

        const defaultslalo = {
          'lat': 33.58989282135868,
          'lon': 130.4207703129221
        }

        let param = {
          'latitude': defaultslalo.lat,
          'longitude': defaultslalo.lon,
          'id': ids
        }

        ApiService.getContents(param)
          .then(data => {
            const cloneInfoData = _.clone(data.info)
            this.positionAllObjects = _.orderBy(cloneInfoData, 'distance', 'ask');
            const firstLatitude = this.positionAllObjects[0].latitude;
            const firstLongitude = this.positionAllObjects[0].longitude
            const loader = new Loader({
              apiKey: ConfigService.getMapApiKey(),
              version: "weekly"
            });

            const typeObj = localStorage.getItem('ncbAtm.type') ? JSON.parse(localStorage.getItem('ncbAtm.type')) : store.getters.searchType;

            let zoomLevel;

            switch(typeObj.type) {
              case 'gps':
                zoomLevel = 15;
                break;

              case 'area':
                zoomLevel = 12;
                break;

              case 'filter':
                zoomLevel = 10;
                break;

              default:
                zoomLevel = 10;
                break;
            }
            
            const mapOptions = {
              center: {lat: Number(firstLatitude), lng: Number(firstLongitude)},
              zoom: zoomLevel,
              disableDefaultUI: true,
              mapId: '4e1bb28009b7a7cb'
            };

            loader.load()
              .then(async (google) => {
                window.google = google;
                this.google = google;
                this.googleMap = new this.google.maps.Map(this.$refs.googlemap, mapOptions);
                this.boundMap = new this.google.maps.LatLngBounds();
                this.positionFilterObjects = _.clone(this.positionAllObjects);
                this.currentLatitude = defaultslalo.lat,
                this.currentLongitude = defaultslalo.lon;
                const CustomMarker = await require('../classes/CustomMarker').default;
                this.currentMarker = new CustomMarker(this.googleMap, defaultslalo.lat, defaultslalo.lon);

                this.google.maps.event.addListener(this.googleMap, 'idle', () => {
                  overlay.hide();
                  const zoom = this.googleMap.getZoom();

                  if (zoom > 20) {
                    this.googleMap.setZoom(18)
                  }
                });
              }).catch(error => {
                console.log(error);
                overlay.hide();
              });
          }, error => {
            console.log(error);
            overlay.hide();
          });
      }, {
        enableHighAccuracy: true,
      });
    },
    changePinFilterType() {
      const clone = _.clone(this.positionAllObjects);
      switch(this.pinFilterTypeModel) {
        // すべて
        case '0':
          this.positionFilterObjects = _.orderBy(_.filter(clone, (position) => {        
            return position;
          }), 'distance', 'asc');
          break;

        // 店舗
        case '1':
          this.positionFilterObjects = _.orderBy(_.filter(clone, (position) => {        
            return position.siten_flg;
          }), 'distance', 'asc');
          break;

        // ATM
        case '2':
          this.positionFilterObjects = _.orderBy(_.filter(clone, (position) => {        
            return !position.siten_flg;
          }), 'distance', 'asc');
          break;
      }
    },
    showSelectAreaDialog() {
      store.dispatch('updateShowSelectAreaDialog', true);
    },
    showGrepFilterDialog() {
      store.dispatch('updateShowGrepFilterDialog', true);
    },
    /**
     * 現在地に戻ります
     */
    panCurrentPosition() {
      navigator.geolocation.getCurrentPosition(position => {
        const lat = position.coords.latitude;
        const lon = position.coords.longitude;

      this.googleMap.panTo(new this.google.maps.LatLng(lat, lon));
      }, error => {
        console.log(error);
        this.$ons.notification.alert({
          'title': '',
          'messageHTML': `位置情報を取得できませんでした。`
        });
      })
    },
    /**
     * マップをズームイン・ズームアウトします
     */
    mapZoom(zoom) {
      let currentZoomLevel = this.googleMap.getZoom();
      let zoomLevel;
      if (zoom === 'plus') {
        zoomLevel = ++currentZoomLevel;
      } else {
        zoomLevel = --currentZoomLevel;
      }
      console.log(zoomLevel)
      this.googleMap.setZoom(zoomLevel);
    },
    /**
     * 店舗検索結果一覧ドロワーを開閉します
     */
    toggleMapSize() {
      this.isMapFullSize = !this.isMapFullSize;
    },
    /**
     * 詳細画面へ遷移します
     */
    hrefInfoDetail(id) {
      this.$router.push({name: 'Detail', params: {animation: 'slide', id: id}});
    },
    /*
     * 1000m以上の数値を整形して返却します(SP)
     */
    toFixedChange(distance) {
      return _.round(distance / 1000, 1).toFixed(1);
    },
    // SP専用
    /**
     * スライドチェンジ時に該当座標へ移動します
     */
    onSlideChange() {
      const index = this.swiper.activeIndex?this.swiper.activeIndex:0;
      const current = this.positionFilterObjects[index];
      //let targetMarker = this.markers[index];
      this.googleMap.panTo(new this.google.maps.LatLng(Number(current.latitude), Number(current.longitude)));
      _.forEach(this.markers, (mark, index) => {
        if (mark.id === current.id) {
          mark.setIcon({
            url: mark.icon.url,
            scaledSize: new this.google.maps.Size(46, 56)
          });
        } else {
          mark.setIcon({
            url: mark.icon.url,
            scaledSize: new this.google.maps.Size(32, 40)
          });
        }
      });
    },
    /**
     * 条件絞り込み画面へ遷移します
     */
    liftGrepSearch() {
      this.$router.push({name: 'GrepInFilter', params: {animation: 'lift'}});
    },
    /**
     * URLをエンコードします
     */
    encodeURL(result) {
      return `http://maps.google.com/maps?q=${result.latitude},${result.longitude}`;
    },
    /**
     * 現在の地図表示エリアから検索します
     */
    reSearch() {
      this.spCardVisibleFlag = false;
      const mapCenterLat = this.googleMap.getCenter().lat();
      const mapCenterLng = this.googleMap.getCenter().lng();
      // 再検索時はモードをすべてに設定。
      const mode = 3;
      //const mode = Number(this.pinFilterTypeModel);
      console.log(`lat: ${mapCenterLat}, lng: ${mapCenterLng}, type: ${this.pinFilterTypeModel}`);
      const param = {
        'mode': mode,
        'latitude': mapCenterLat,
        'longitude': mapCenterLng
      }
      ApiService.position(param)
        .then(data => {
          const ids = data.info;
          store.dispatch('updateResult', ids);
          const typeParam = {
              'type': 'gps',
              'text': "周辺エリアから探す"
            }
            store.dispatch('updateSearchType', typeParam);
            this.googleMapOld = this.googleMap;
            this.swiper.activeIndex=0;
          // ApiService.getContents(param)
          //   .then(data => {
          //     this.googleMapOld = this.googleMap;
          //     const cloneInfoData = _.clone(data.info)
          //     this.positionAllObjects = _.orderBy(cloneInfoData, 'distance', 'ask');

          //   }, error => {
          //     console.log(error);
          //   });
        }, error => {
          console.log(error);
        });
    },
    infoClose() {
      this.spCardVisibleFlag = false;

      _.forEach(this.markers, (mark, index) => {
          mark.setIcon({
            url: mark.icon.url,
            scaledSize: new this.google.maps.Size(32, 40)
          });
      });
  
    }
  },
  created: function() {
  },
  mounted: function() {
    if (this.isCurrentRoute) {
      // const info = JSON.parse(decodeURIComponent(this.$route.params.info));
      // store.dispatch('updateResult', info.id);
      const ids = localStorage.getItem('ncbAtm.result') ? JSON.parse(localStorage.getItem('ncbAtm.result')) : store.getters.allResults;
      this.mapRender(ids);

      this.isMounted = true;
      this.$nextTick(() => {
        let dragBarTtitleGestureElement = this.$ons.GestureDetector(document.getElementById('drag_area'));
        dragBarTtitleGestureElement.on('dragup dragdown', (event) => {
          const page = document.getElementById('map_page');
          const clientY = page.clientHeight - event.gesture.touches[0].clientY - 72;

          if (clientY > 0) {
            if (clientY < page.clientHeight / 20) {
              this.transitionSpeed = 0;
              this.positionY = -clientY;
              this.isListOpen = false;
            } else {
              this.transitionSpeed = 0.2;
              this.positionY = -page.clientHeight + 72;
              this.isListOpen = true;
            }
          }
        });
      });
    }

    setTimeout(() => {
      this.isPageShow = true;
    }, 0);
  },
}
</script>
<style lang="scss" scoped>
@import "../assets/styles/map.scss";
</style>